import { Text, VStack } from "@chakra-ui/react"
import { useContext, useEffect, useState } from "react"
import { findWhere } from "underscore"
import DefaultLayout from "../../../layouts/DefaultLayout"
import { UserContext, UserContextProps } from "../../../providers/UserProvider"
import { GetToken } from "../../../services/Tableau"

const dashboards = [
    {
        category: 'LCBO',
        url: 'https://tableau.analyticsmart.com/t/Molson/views/MolsonAPPGetIn/GetInDashboard'
    },
    {
        category: 'LCO',
        url: 'https://tableau.analyticsmart.com/t/Molson/views/LCOMolsonAPPGetIn/LCOGetInDashboard'
    },
    {
        category: 'GROCERY',
        url: 'https://tableau.analyticsmart.com/t/Molson/views/GroceryMolsonAPPGetIn/GroceryGetInDashboard'
    }
]


const GetInPage = () => {
    const [token, setToken] = useState<string>('')
    const [dashboard_url, setDashboardUrl] = useState<string>('')
    const { location_number, category, user } = useContext(UserContext) as UserContextProps
    const [is_ready, setIsReady] = useState<boolean>()


    useEffect(() => {
        (async () => {
            //  set dashboard
            const dashboard = findWhere(dashboards, { category: category })
            if (dashboard) {
                setDashboardUrl(() => dashboard.url)
            } else {
                setDashboardUrl(() => '')
            }

            //  set token
            const { data } = await GetToken()
            const { token } = data
            setToken(() => token)
            setIsReady(()=> true)
        })()
    }, [category])

    return (
        <DefaultLayout>
            <VStack pb={'40px'} minH={'700px'} w={'full'} align={'center'}>
                {(is_ready && token && user && dashboard_url) &&
                    <tableau-viz
                        id='tableau-viz'
                        src={dashboard_url}
                        width='1000'
                        height='1200'
                        hide-tabs={true}
                        token={token}
                        onFilterChanged={() => alert('filter changed')}
                        toolbar='bottom'>
                        <viz-filter field='CLIENT_ID' value={'4d1c6785-6081-470e-b3eb-5ac370d5d768'} />
                        {category === 'LCBO' &&
                            <viz-filter field='Location Number' value={location_number} />
                        }
                        {category === 'LCO' &&
                            <viz-filter field='Agency Number' value={location_number} />
                        }
                        {category === 'GROCERY' &&
                            <viz-filter field='Grocery Number' value={location_number} />
                        }
                    </tableau-viz>
                }

                { !is_ready &&
                    <VStack justify={'center'} alignItems={'center'} w={'full'} h={'700px'}>
                        <Text fontSize={'3xl'}>Loading, please wait...</Text>
                    </VStack>
                }
                { (is_ready && !dashboard_url) &&
                    <VStack justify={'center'} alignItems={'center'} w={'full'} h={'700px'}>
                        <Text fontSize={'3xl'}>No available dashboard for {category.toLowerCase()}</Text>
                    </VStack>
                }

            </VStack>
        </DefaultLayout>
    )
}

export default GetInPage